import React, { useEffect, useState } from 'react'
import { Button, DataTable, DataTableRow, LabelTooltip, Separator, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { usePageView } from '@fs/zion-analytics'
import { viewResults } from '../../../services/rftService'
import useNotifications from '../../../hooks/useNotifications'
import { getStringPixelWidth } from '../../../util/StringUtil'
import { usePageTitle } from '../../app/PageTitleContext'

export default function RftResultsPreview({ match }) {
  usePageView({ page_detail: 'DMConsole:RftResultsPreview' })
  const { error } = useNotifications()
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tools.rftResultsPreview'))
  const [previewResults, setPreviewResults] = useState()
  const horizontalScroll = css`
    overflow-x: scroll;
    overflow-y: hidden;
    border: 1px solid ${colors.gray60};
    border-radius: 5px;
  `

  const getTruncatedStringLength = (str) => {
    for (let i = 10; i < str.length; i++) {
      if (getStringPixelWidth(str.substr(0, i)) > 160) {
        return i
      }
    }
    return 10
  }

  useEffect(() => {
    viewResults(match.params.jobId)
      .then((response) => {
        setPreviewResults(response.data)
      })
      .catch((err) => {
        error(t('rft.preview.error', 'Error retrieving results preview'), err)
      })
  }, [error, match.params.jobId, t])

  const columnProps = {}

  return (
    <>
      <Button emphasis="medium" to="/tools/rftQueries">
        {t('rft.preview.backToResultsList', 'Back To Results List')}
      </Button>
      <Separator />
      {previewResults?.length === 0 && <div>{t('rft.preview.noResults', 'No Results')}</div>}
      {previewResults?.length > 0 && (
        <div css={horizontalScroll}>
          <DataTable
            columns={previewResults[0].map((result) => {
              return { label: result }
            })}
          >
            {previewResults?.slice(1)?.map((resultRow, rowNum) => {
              resultRow.forEach((str, index) => {
                let result = str
                if (getStringPixelWidth(str) > 190) {
                  const truncatedStringLength = getTruncatedStringLength(str)
                  result = <LabelTooltip label={str} target={`${str.substr(0, truncatedStringLength)}...`} />
                }
                columnProps[`column${index + 1}`] = result
              })
              return <DataTableRow key={`${columnProps.column1}_${rowNum - 1}`} {...columnProps} />
            })}
          </DataTable>
        </div>
      )}
    </>
  )
}
